import { MatchParams } from '@/types/match'

const getLinkFromPageObject = ({ projectSlug, env, menuSlug, pageSlug }: MatchParams): string => {
  return [String(projectSlug), String(env), menuSlug, pageSlug].filter((slug) => !!slug).join('/')
}

export default getLinkFromPageObject
